import PropTypes from 'prop-types';

const BillingCategoryType = PropTypes.shape({
  id: PropTypes.string,
  parent_id: PropTypes.string,
  name: PropTypes.string,
  account: PropTypes.string,
  ledger_account_code: PropTypes.string,
  adjustment_code: PropTypes.string,
  position: PropTypes.number,
  contact: PropTypes.bool,
  active: PropTypes.bool,
  category_type: PropTypes.string
});

BillingCategoryType.children = PropTypes.arrayOf(BillingCategoryType);

export default BillingCategoryType;
